import React from 'react';

import styles from './SearchBar.scss';
import AvailableCount from './components/AvailableCount';
import SearchInput from './components/SearchInput/SearchInput';
import UpcomingToggle from './components/UpcomingToggle/UpcomingToggle';

interface Props {
  hideUpcomingToggle?: boolean;
}

const SearchBar: React.FC<Props> = ({ hideUpcomingToggle }) => (
  <div className={styles.searchBarContainer} data-testid="search-bar">
    <SearchInput />
    {!hideUpcomingToggle && <UpcomingToggle />}
    <AvailableCount />
  </div>
);

export default SearchBar;
